import React, { useEffect } from 'react';

export const CannellaMediaEvent = ({ leadSource }) => {
  useEffect(() => {
    if (leadSource === 'Website Home' && window.location.hostname === 'myportal.setcpros.com') {
      const script = document.createElement('script')
      script.src = 'https://df8nroy20256x.cloudfront.net/cannella_setcpros_event.js'
      script.async = true
      document.body.appendChild(script)

      return () => {
        document.body.removeChild(script)
      }
    }
  }, [leadSource])

  return <img id='cannellamedia' alt='Cannella Media' style={{ display: 'none' }} />
}